import React from 'react'
import GooglePlayButton from './GooglePlayButton'
import AppleStoreButton from './AppleStoreButton'

type ClassNames = {
    main: string
    buttons: {
        apple: string
        google: string
    }
    icons: string
}

interface StoreButtonsProps extends Partial<ClassNames> {
    appleStoreUrl?: string
    googlePlayUrl?: string
}

const StoreButtons: React.FC<StoreButtonsProps> = (props) => (
    <div className={props?.main ?? ''}>
        <AppleStoreButton
            className={props?.buttons?.apple ?? ''}
            iconClassName={props?.icons ?? ''}
            url={props.appleStoreUrl}
            location="ready_to_play"
        />
        <GooglePlayButton
            className={props?.buttons?.google ?? ''}
            iconClassName={props?.icons ?? ''}
            url={props.googlePlayUrl}
            location="ready_to_play"
        />
    </div>
)

export default StoreButtons
